/**
 * module-15.js
 *
 * Javascript for Module 15
 *
 * @package Wordpress/imhof-digital
 * @since   5.6.0
 * @author  Imhof Digital <info@imhof-digital.de>
 */

jQuery( document ).ready( function( $ ) {
   // declare strict mode
   'use strict';

   if( $( '.module-15.modulecontainer' ).length > 0 ) {

      /**
       * module 15 object
       *
       * @since   5.6.0
       * @method  self::adjustDisplay()   Adjusts the display of the slides
       * @method  self::init()            Initiates module 15 object
       *
       */
      idscript.module15 = {

         /**
          * adjustDisplay()
          *
          * Adjusts the display of the slides
          *
          * @since   5.6.0
          * @usedby  method   self::init()
          */
         adjustDisplay: function() {
            var slider = $( '.sow-slider-images' );
            var slides = $( '.sow-slider-images > li' );
            //set the height of the slides-container
            $( slides ).each( function( index, element ) {

               if( $( element )[ 0 ].offsetHeight > $( slider )[ 0 ].offsetHeight ) {
                  $( slider ).css( 'height', $( element )[ 0 ].offsetHeight+'px' );
               }
            } );
            //adjust the slides to vertical center
            $( slides ).each( function( index, element ) {
               $( element ).css( {
                  marginTop: ( $( slider )[ 0 ].offsetHeight - $( element )[ 0 ].offsetHeight ) / 2 + 'px'
               } );
            } );
            return;
         },

         /**
          * init()
          *
          * Initiates module 15 object
          *
          * @since   5.6.0
          * @uses    method   self::adjustDisplay()
          */
         init: function() {
            //the timeout is set to give the slider a moment to be loaded ready
            setTimeout( idscript.module15.adjustDisplay, 1000 );
            $( window ).on( 'resize', function() {
               $( '.sow-slider-images' ).css( 'height', 'auto' );
               idscript.module15.adjustDisplay();
            });
            return;
         }
      };
      idscript.module15.init();
   }
});
